module.exports = __webpack_public_path__ + "media/images/icons/vk-9b16cd8c5d41bd0ffcb455eefce38ab6.svg";